import api from 'api/apiInstance';

export function clientNotificationMarkAsReadApi(path: string) {
  return {
    path,
    POST: () => api.post(path),
  };
}
